import { User } from '../model/shared/user/user';
import { BaseResponse } from './internal/baseresponse';

export class LoginResult extends BaseResponse {
  data: User;
}



// WEBPACK FOOTER //
// ./src/app/response/loginresult.ts